<form [formGroup]="organizationForm">
  <markant-input
    *ngIf="organizationForm.controls['name'] as name"
    class="registration-form-input hidden-placeholder"
    id="organizationName"
    data-cy="input-organization-name"
    name="name"
    required
    [formControlName]="'name'"
    [error]="
      name.errors | formControlError: showError || name.touched || name.dirty
    "
    [errorText]="
      name.errors
        | formControlKeyError
          : 'organization.details.fields.name.validation'
          : showError || name.touched || name.dirty
        | transloco
    "
    [label]="pathToTranslation + 'name.label' | transloco"
    [placeholder]="pathToTranslation + 'name.placeholder' | transloco"
    [showLabelHint]="true"
    [outlined]="true"
  ></markant-input>
  <div class="flex-spaced-between">
    <markant-input
      *ngIf="organizationForm.controls['street'] as street"
      class="registration-form-input"
      id="organizationStreet"
      data-cy="input-organization-street"
      name="street"
      required
      style="width: 80%"
      [formControlName]="'street'"
      [error]="
        street.errors
          | formControlError: showError || street.touched || street.dirty
      "
      [errorText]="
        street.errors
          | formControlKeyError
            : 'organization.details.fields.address.street.validation'
            : showError || street.touched || street.dirty
          | transloco
      "
      [label]="pathToTranslation + 'address.street.label' | transloco"
      [showLabelHint]="true"
      [outlined]="true"
    ></markant-input>
    <markant-input
      *ngIf="organizationForm.controls['streetNumber'] as streetNumber"
      class="registration-form-input"
      id="organizationStreetNumber"
      data-cy="input-organization-street-number"
      name="streetNumber"
      required
      style="width: 20%"
      [formControlName]="'streetNumber'"
      [error]="
        streetNumber.errors
          | formControlError
            : showError || streetNumber.touched || streetNumber.dirty
      "
      [errorText]="
        streetNumber.errors
          | formControlKeyError
            : 'organization.details.fields.address.streetNumber.validation'
            : showError || streetNumber.touched || streetNumber.dirty
          | transloco
      "
      [label]="pathToTranslation + 'address.streetNumber.label' | transloco"
      [showLabelHint]="true"
      [outlined]="true"
    ></markant-input>
  </div>

  <div class="flex-spaced-between">
    <markant-input
      *ngIf="organizationForm.controls['zipCode'] as zipCode"
      class="registration-form-input"
      id="organizationZipCode"
      data-cy="input-organization-ZipCode"
      name="zipCode"
      required
      style="width: 35%; min-width: 180px"
      [formControlName]="'zipCode'"
      [error]="
        zipCode.errors
          | formControlError: showError || zipCode.touched || zipCode.dirty
      "
      [errorText]="
        zipCode.errors
          | formControlKeyError
            : 'organization.details.fields.address.zipCode.validation'
            : showError || zipCode.touched || zipCode.dirty
          | transloco
      "
      [label]="pathToTranslation + 'address.zipCode.label' | transloco"
      [showLabelHint]="true"
      [outlined]="true"
    ></markant-input>

    <markant-input
      *ngIf="organizationForm.controls['city'] as city"
      class="registration-form-input"
      id="organizationCity"
      data-cy="input-organization-city"
      name="city"
      required
      style="width: 65%"
      [formControlName]="'city'"
      [error]="
        city.errors | formControlError: showError || city.touched || city.dirty
      "
      [errorText]="
        city.errors
          | formControlKeyError
            : 'organization.details.fields.address.city.validation'
            : showError || city.touched || city.dirty
          | transloco
      "
      [label]="pathToTranslation + 'address.city.label' | transloco"
      [showLabelHint]="true"
      [outlined]="true"
    ></markant-input>
  </div>
  <div class="registration-form-input country-select">
    @if (organizationForm.controls['countryCode']; as countryCode) {
      <markant-platform-ui-country-select
        id="organizationCountry"
        name="countryCode"
        data-cy="country-code-select"
        [error]="
          countryCode.errors
            | formControlKeyError
              : 'organization.details.fields.address.countryCode.validation'
              : showError || countryCode.dirty
            | transloco
        "
        [label]="pathToTranslation + 'address.countryCode.label' | transloco"
        [placeholder]="
          pathToTranslation + 'address.countryCode.placeholder' | transloco
        "
        [required]="true"
        [outlined]="true"
        [showLabelHint]="true"
        [control]="$any(countryCode)"
        (valueChanged)="onCountryChanged()"
      >
      </markant-platform-ui-country-select>
    }
  </div>
  <div class="input-block">
    @if (organizationForm.controls.phone; as phone) {
      <markant-input
        [error]="
          phone.errors
            | formControlError: showError || phone.touched || phone.dirty
        "
        formControlName="phone"
        [errorText]="
          phone.errors
            | formControlKeyError
              : 'organization.details.fields.phone.validation'
              : showError || phone.touched || phone.dirty
            | transloco
        "
        [label]="pathToTranslation + 'phone.label' | transloco"
        [showLabelHint]="phone | formControlIsRequired"
        class="registration-form-input"
        id="organizationPhone"
        data-cy="input-organization-phone"
        name="phone"
        [outlined]="true"
        [required]="phone | formControlIsRequired"
      ></markant-input>
    }
  </div>
</form>
